import React, { Component } from 'react';
import { connect } from 'react-redux';
import {ProgressSpinner} from 'primereact/progressspinner';
import {InputText} from 'primereact/inputtext';
import {Panel} from 'primereact/panel';
import {Dropdown} from 'primereact/dropdown';
// import {DataTable} from 'primereact/datatable';
// import {Column} from 'primereact/column';
import { SAPDATA, TIMESHEET_TYPE, REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, EMP_GROUP_SUBMENU_ID } from '../../../shared/Config';

import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

class AddEmployeeGroup extends Component {
    state = {
        sapData: [],
        timeSheets: [],
        policies: [
            {label : 'Policy 1' , value: '1'},
            {label : 'Policy 2', value: '2'}
        ],
   
        shifts: [
            {label : 'Rotating Shift' , value: 1},
            {label : 'Ordinary Shift' , value: 2},
        ],
        schedules : [
            {orderofpws : "1", periodic: 'Periodic WorkSchedule'}
        ],
        type: 'add',
        code:'',
        groupname:'',
        weeklyholidays:'',
        weeklyworkinghours:'',
        sapIntegration:null,
        timeSheet:null,
        policy:null,
        holiday: null,
        shift:null,
        empGruopId: '',
        createdBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate : new Date(),
        loading:false,
        touch : false
    }


    // actionTemplate = (rowData, column) => {
    //     return <div>
    //         <Button type="button" icon="pi pi-trash" className="p-button-danger" ></Button>
    //     </div>;
    // }


    componentDidMount(){    
        let type = this.props.match.params.type;   
        this.getAccess = HASACCESS(EMP_GROUP_SUBMENU_ID);
        this.props.getMasterKeywordList('TimeOffPolicy'); 
        this.props.getMasterKeywordList('holiday'); 
        this.setState({type:type,sapData:SAPDATA,timeSheets:TIMESHEET_TYPE});
        this.props.getMasterTableList('Employee/GetEmployeeGroups'); 
        //this.props.getMasterTableCommonList('Holiday/GetHolidays','holidayLists',this.props.commonLists); 
       
        if(type !== 'add'){
            this.setState({loading:true});
            setTimeout(()=>{
                this.setState({loading:false});
                this.fetchSingleProcess();
            },3000)
            
        }
    }
    
    fetchSingleProcess = () =>{

        let id = this.props.match.params.id;   
        let storageItems = this.props.tableLists;
        if(storageItems){
            let filterData = storageItems.filter(list => {
                return list.empGruopId === id;
            }).reduce((arr,el) => {
                return el;
            },{});
            if(filterData){
                this.setState({empGruopId:filterData.empGruopId,code:filterData.code,groupname:filterData.name,weeklyholidays:filterData.weeklyHolidays,weeklyworkinghours:filterData.weeklyHours,sapIntegration:filterData.sapIntegration,shift:filterData.shiftType,timeSheet:filterData.timesheetType,policy:filterData.timeOfTypePolicy,holiday:filterData.holidayType,createdBy:filterData.createdBy,createdDate:filterData.createdDate})
            }
        }

    }




    add = () => {
        
        if(this.state.code === ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Code is required'});
            return;
        }
     
        if(this.state.groupname === ''){
            this.growl.show({severity: 'error', summary: null, detail: 'Group name is required'});
            return;
        }
     

        if(this.state.sapIntegration === null){
            this.growl.show({severity: 'error', summary: null, detail: 'SAP Integration is required'});
            return;
        }

        var data = {
            Code: this.state.code,            
            Name: this.state.groupname,
            WeeklyHours: (this.state.weeklyworkinghours!=='') ? this.state.weeklyworkinghours : 0,
            WeeklyHolidays: (this.state.weeklyholidays!=='') ? this.state.weeklyholidays : 0,
            HolidayType:this.state.holiday,
            TimeOfTypePolicy: this.state.policy,
            Active: true,
            ShiftType:this.state.shift,
            CreateSes:true,
            TimesheetType: this.state.timeSheet,
            SapIntegration: this.state.sapIntegration,
            CreatedBy: this.state.createdBy,
            CreatedDate: this.state.createdDate,
        }
        
        if(this.state.type === 'edit'){
            data.EmpGruopId = this.state.empGruopId;
            data.updatedBy = (this.props.loggedUserDetail.userName) ?? 'Admin';
            data.updatedDate = new Date();
        }

        this.props.processDynamicData('employeeGroup',this.state.type,data,'Employee/GetEmployeeGroups');
    }

    changeData = (e) =>{
        let { name, value } = e.target;
        this.setState({[name]:value,touch:true});
    }

    resetData = () => {
        this.setState({type:'add',code:'',groupname:'',weeklyholidays:'',weeklyworkinghours:'',sapIntegration:null,timeSheet:null,policy:null,holiday:null});
    }

    

    render() {   

        if(this.props.success){
            REDIRECT_TO_URL('/employee-group/',this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

     
       
        // let holidayLists = [];
        // let holidayData = [];
        // if(this.props.commonLists){
        //     Object.entries(this.props.commonLists).map(([key,value],i) => {
        //             let objKey = Object.keys(value);
        //             if(objKey[0] === 'holidayLists'){
        //                 holidayLists = value['holidayLists'];
        //             }
        //     });
            
        //     if(holidayLists && holidayLists.length > 0){
        //         holidayData = holidayLists.map(holiday=>{
        //             return{label : holiday.name, value:holiday.holidayid};
        //         })
        //     }

        // }


        let isEnabled = (this.state.touch === true) && (this.state.code!=='') && (this.state.groupname!=='') && (this.state.sapIntegration!==null);

        return (
            <div className="p-grid">
               { this.props.loading && <div className="page-loader"></div>}
               { this.state.loading && <div className="page-loader"></div>}
               { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
               { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
               <Toast ref={(el) => this.growl = el} />

               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Add Employee Group</h1>
                       
                       
                        <div className="p-grid mt2">
                            
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Code <span className="requiredColor">*</span></label>
                                <div className="mt1"> <InputText className="p-col-12" name="code" value={this.state.code}  placeholder="code" onChange={this.changeData}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Group Name <span className="requiredColor">*</span></label>
                                <div className="mt1"> <InputText className="p-col-12" name="groupname" value={this.state.groupname} onChange={this.changeData} placeholder="Group Name"/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Weekly Holidays</label>
                                <div className="mt1"> <ProgressSpinner className="width100" name="weeklyholidays" value={this.state.weeklyholidays} onChange={this.changeData} placeholder="Weekly Holidays"/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Weekly Working Hours </label>
                                <div className="mt1"> <ProgressSpinner className="width100" name="weeklyworkinghours" value={this.state.weeklyworkinghours} onChange={this.changeData} placeholder="Weekly Working Hours"/></div>                                
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="SAP Integration" toggleable={true}>
                               
                                    <div className="p-grid mt05">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">SAP Integration <span className="requiredColor">*</span></label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <Dropdown className="p-col-12" placeholder="Choose SAP Integration" options={this.state.sapData} name="sapIntegration" value={this.state.sapIntegration} onChange={this.changeData} {...DROPDOWN_CONFIG} />
                                        </div>
                                        
                                    </div> 
                                </Panel>
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Time Sheet Category" toggleable={true}>
                               
                                    <div className="p-grid mt05">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Choose Positive/Negative TS</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <Dropdown className="p-col-12" placeholder="Choose Positive/Negative TS" options={this.state.timeSheets} name="timeSheet" value={this.state.timeSheet} onChange={this.changeData}  {...DROPDOWN_CONFIG}  />
                                        </div>
                                        
                                    </div> 
                                </Panel>
                            </div>



                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Time-off Type Policy" toggleable={true}>
                               
                                    <div className="p-grid mt05">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Choose Policy</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <Dropdown className="p-col-12" placeholder="Choose Policy" options={this.props.TimeOffPolicy} name="policy" value={this.state.policy} onChange={this.changeData} {...DROPDOWN_CONFIG}  />
                                        </div>
                                        
                                    </div> 
                                </Panel>
                            </div>



                            <div className="p-col-12 p-md-6 p-lg-6 mt3">
                                <Panel header="Holidays" toggleable={true}>
                               
                                    <div className="p-grid mt05">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Choose Holidays</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <Dropdown className="p-col-12" placeholder="Choose Holidays" options={this.props.holidays} name="holiday" value={this.state.holiday} onChange={this.changeData}  {...DROPDOWN_CONFIG} />
                                        </div>
                                        
                                    </div> 
                                </Panel>
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-12 mt3">
                                <Panel header="Add Periodic Work Schedule" style={{background:'red'}} toggleable={true}>
                               
                                    <div className="p-grid mt05">
                                        <div className="p-col-12 p-md-6">
                                            <label htmlFor="input">Rotating / Ordinary Shift</label>
                                        </div>
                                        <div className="p-col-12 p-md-6">
                                        <Dropdown className="p-col-12" placeholder="Choose Rotating / Ordinary Shift" options={this.state.shifts} name="shift" value={this.state.shift} onChange={event => this.setState({shift: event.value})} {...DROPDOWN_CONFIG}  />
                                        </div>

                                        {/* <div className="p-lg-12">
                                            <DataTable value={this.state.schedules} reorderableColumns={true}
                                                reorderableRows={true} onRowReorder={(e) => this.setState({schedules: e.value})}>
                                                <Column rowReorder={true} style={{width: '3em'}} />
                                                <Column columnKey="orderofpws" field="orderofpws" header="Order of PWS"/>
                                                <Column columnKey="periodic" field="periodic" header="Periodic Work Schedule" />
                                                 <Column body={this.actionTemplate} header="Delete" style={{textAlign:'center', width: '8em'}}/>  
                                            </DataTable>
                                        </div> */}
                                        
                                    </div> 
                                </Panel>
                            </div> 


                            
                            <div className="p-col-12 p-lg-12">

                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/employee-group/"} />

                                 


                                {/* <div className="mt1">
                                    { (this.state.type.toLowerCase() === 'add' || this.state.type.toLowerCase() === 'edit') ?
                                    <Button disabled={!isEnabled} style={{float:'right'}} label={labelName} icon={"pi "+iconName} className="ml1" onClick={()=>this.add()} />
                                    : null
                                    }

                                    { (this.state.type.toLowerCase() === 'add') ?
                                        <Button style={{float:'right'}} label="Reset" icon="pi pi-replay" className="ml1 p-button-secondary" onClick={this.resetData} /> :

                                        <Link to="/employee-group/"><Button style={{float:'right'}} label="Cancel" icon="pi pi-times" className="ml1 p-button-secondary" /></Link>
                                    }
                                    
                                    
                                    <Link to="/employee-group/"><Button style={{float:'right'}} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" /></Link>
                                </div>    */}

                            </div>
                     
                        </div>
                    
           
                       
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
        commonLists : state.master.commonLists,
        holidays : (state.keyword.holiday!==undefined) ? state.keyword.holiday : [],
        TimeOffPolicy : (state.keyword.TimeOffPolicy!==undefined) ? state.keyword.TimeOffPolicy : [],
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableCommonList: (table,listName,commonLists) => dispatch(actions.getMasterTableCommonList(table,listName,commonLists)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(AddEmployeeGroup);